import { render, staticRenderFns } from "./WarehouseStocking.vue?vue&type=template&id=b49e9bb6&"
import script from "./WarehouseStocking.vue?vue&type=script&lang=js&"
export * from "./WarehouseStocking.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseStocking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports